"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFeatureFlagKey = isValidFeatureFlagKey;
/** Validate a feature flag key format (snake_case, alphanumeric + underscore) */
function isValidFeatureFlagKey(key) {
    return /^[a-z][a-z0-9_]*$/i.test(key) && key.length <= 100 && key.length > 0;
}
